export default __webpack_public_path__ + "static/media/classButtonImage_scones.57addf2e.jpg";